import { Col } from 'reactstrap';

import { Row } from 'reactstrap';
import { format } from 'rut.js';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../../../locales/translations';

interface TutorDetailsBoxProps {
  tutorName: string;
  tutorId: string;
}

export default function TutorDetailsBox({
  tutorName,
  tutorId,
}: TutorDetailsBoxProps) {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_FILE_EDUCATIONAL_BACKGROUND,
  );
  return (
    <div
      style={{
        minHeight: '65px',
        width: '100%',
        background: '#f4f4f4',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Row style={{ width: '100%', height: '100%' }}>
        <Col xs={12} md={7}>
          <div className="text-primary fw-700 text-uppercase fs-14">
            {t(`tutor`)}
          </div>
          <div className="fs-14 text-primary">{tutorName}</div>
        </Col>
        <Col xs={12} md={5}>
          <div className="text-primary fw-700 text-uppercase fs-14">
            {t(`id`)}
          </div>
          <div className="fs-14 text-primary">
            {format(tutorId, { dots: true })}
          </div>
        </Col>
      </Row>
    </div>
  );
}
